const HOSTED_HOSTNAMES = new Set([
  'specimen-observer.web.app',
  'specimen-observer.firebaseapp.com',
  'specimen.observer',
  'www.specimen.observer',
]);

export function isHostedSite(): boolean {
  return typeof window !== 'undefined' && HOSTED_HOSTNAMES.has(window.location.hostname);
}
